module.exports = __webpack_public_path__ + "img/dream-journal_B095GLNK1N.e4ae2bc2.jpg";